export const dollarGeneralAllFields = [
  {
    groupName: 'Header',
    fields: [
      {
        dataType: 'string',
        displayName: 'Type',
        fieldFullPath: 'dProperties.type',
      },
      {
        dataType: 'string',
        displayName: 'National Brand Target',
        fieldFullPath: 'qaSpecification.nationalBrandTarget',
      },
      {
        dataType: 'string',
        displayName: 'SKU Type',
        fieldFullPath: 'dProperties.sKUType',
      },
      {
        dataType: 'string',
        displayName: 'National Brand Target UPC',
        fieldFullPath: 'qaSpecification.nationalBrandTargetUpc',
      },
      {
        dataType: 'string',
        displayName: 'Retail Banner',
        fieldFullPath: 'dProperties.retailer',
      },
      {
        dataType: 'string',
        displayName: 'SmartLabel Template',
        fieldFullPath: 'eCommerce.smartLabelTemplate',
      },
      {
        dataType: 'string',
        displayName: 'Applicable Reference Standard',
        fieldFullPath: 'dProperties.applicableReferenceStandard',
      },
      {
        dataType: 'string',
        displayName: 'Supplier Location',
        fieldFullPath: 'dProperties.supplierLocation',
      },
      {
        dataType: 'string',
        displayName: 'Category I',
        fieldFullPath: 'qaSpecification.category1Name',
      },
      {
        dataType: 'string',
        displayName: 'Category II',
        fieldFullPath: 'qaSpecification.category2Name',
      },
      {
        dataType: 'string',
        displayName: 'Category III',
        fieldFullPath: 'qaSpecification.category3Name',
      },
      {
        dataType: 'string',
        displayName: 'Category IV',
        fieldFullPath: 'qaSpecification.category4Name',
      },
    ],
    childGroups: null,
  },
  {
    groupName: 'Product Specification',
    fields: [
      {
        dataType: 'string',
        displayName: 'Quality Guarantee',
        fieldFullPath:
          'dProperties.bpSKULabelling.leftLanguage.qualityGuarantee',
      },
      {
        dataType: 'string',
        displayName: 'Compliance Statement',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.complianceStatement',
      },
      {
        dataType: 'string',
        displayName: 'Health Claims',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.healthClaims',
      },
      {
        dataType: 'boolean',
        displayName: 'Gluten Free Claim',
        fieldFullPath: 'tdcProperties.glutenFreeYN',
      },
      {
        dataType: 'string',
        displayName: 'Structure / Function Claims',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.structureFunctionClaims',
      },
      {
        dataType: 'string',
        displayName: 'Relative / Comparative Claims',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.relativeComparativeClaims',
      },
      {
        dataType: 'string',
        displayName: 'Safe Handling Instructions',
        fieldFullPath: 'qaSpecification.safeHandlingInstructions',
      },
      {
        dataType: 'string',
        displayName: 'Live and Active Culture',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.liveActiveCultures',
      },
      {
        dataType: 'string',
        displayName: 'USDA / Canadian Grading',
        fieldFullPath: 'qaSpecification.qaSpecProductSpecification.usdaGrade',
      },
      {
        dataType: 'string',
        displayName: 'USDA Shield ID',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.usdaShieldId',
      },
      {
        dataType: 'string',
        displayName: 'Eggs Grading',
        fieldFullPath: 'qaSpecification.qaSpecProductSpecification.eggsGrading',
      },
      {
        dataType: 'boolean',
        displayName: 'USDA WIC Eligible',
        fieldFullPath:
          'qaSpecification.qaSpecProductSpecification.wicCompliant',
      },
      {
        dataType: 'boolean',
        displayName: 'MSDS Required?',
        fieldFullPath: 'tdcProperties.mSDS',
      },
    ],
    childGroups: [
      {
        groupName: 'Date Coding',
        fields: [
          {
            dataType: 'string',
            displayName: 'Date Code – Open / Closed',
            fieldFullPath: 'tdcProperties.codeDateStamp',
          },
          {
            dataType: 'string',
            displayName: 'Date Code Type',
            fieldFullPath: 'tdcProperties.codeDateType',
          },
          {
            dataType: 'string',
            displayName: 'Date Code Formula',
            fieldFullPath: 'tdcProperties.codeDateFormula',
          },
          {
            dataType: 'string',
            displayName: 'Date Code Example',
            fieldFullPath: 'tdcProperties.codeDateExample',
          },
          {
            dataType: 'string',
            displayName: 'Batch Code Example',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.batchCodeExample',
          },
          {
            dataType: 'string',
            displayName: 'Lot Code Example',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.lotCodeExample',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Statement',
        fields: [
          {
            dataType: 'string',
            displayName: 'GMO Statement',
            fieldFullPath: 'tdcProperties.gMOStatement',
          },
          {
            dataType: 'string',
            displayName: 'Non-GMO Statement',
            fieldFullPath: 'tdcProperties.nonGmoGmoStatement',
          },
          {
            dataType: 'string',
            displayName: 'Product Contains Bioengineered Ingredients',
            fieldFullPath:
              'tdcProperties.productContainsBioengineeredIngredients',
          },
          {
            dataType: 'string',
            displayName: 'Bioengineered Ingredients Statement',
            fieldFullPath: 'tdcProperties.bioengineeredStatement',
          },
          {
            dataType: 'string',
            displayName: 'RBGH/BST Statement',
            fieldFullPath: 'tdcProperties.rbghBstStatement',
          },
          {
            dataType: 'string',
            displayName: 'California Prop 65 Warning Statement',
            fieldFullPath: 'tdcProperties.californiaProp65WarningStatement',
          },
          {
            dataType: 'string',
            displayName: 'Fair Trade Statement',
            fieldFullPath: 'tdcProperties.fairTradeStatement',
          },
          {
            dataType: 'string',
            displayName: 'USDA Statement',
            fieldFullPath: 'tdcProperties.uSDAStatement',
          },
        ],
        childGroups: [
          {
            groupName: 'Nonfood Ingredient Statement',
            fields: [
              {
                dataType: 'string',
                displayName: 'Value',
                fieldFullPath:
                  'nonfoodIngredient.nonfoodIngredientStatement.value',
              },
              {
                dataType: 'string',
                displayName: 'Language Code',
                fieldFullPath:
                  'nonfoodIngredient.nonfoodIngredientStatement.languageCode',
              },
              {
                dataType: 'string',
                displayName: 'Code List Version',
                fieldFullPath:
                  'nonfoodIngredient.nonfoodIngredientStatement.codeListVersion',
              },
              {
                dataType: 'string',
                displayName: 'Formatting Pattern',
                fieldFullPath:
                  'nonfoodIngredient.nonfoodIngredientStatement.formattingPattern',
              },
              {
                dataType: 'int',
                displayName: 'Sequence Number',
                fieldFullPath:
                  'nonfoodIngredient.nonfoodIngredientStatement.sequenceNumber',
              },
            ],
            childGroups: null,
          },
        ],
      },
      {
        groupName: 'Locations',
        fields: [
          {
            dataType: 'string',
            displayName: 'Target Market',
            fieldFullPath: 'targetMarket',
          },
        ],
        childGroups: [
          {
            groupName: 'Country of Origin',
            fields: [
              {
                dataType: 'string',
                displayName: 'Country Code',
                fieldFullPath:
                  'placeOfItemActivity.placeOfProductActivity.countryOfOrigin.countryCode',
              },
              {
                dataType: 'string',
                displayName: 'Country Subdivision Code',
                fieldFullPath:
                  'placeOfItemActivity.placeOfProductActivity.countryOfOrigin.countrySubdivisionCode',
              },
            ],
            childGroups: null,
          },
        ],
      },
      {
        groupName: 'Shelf life',
        fields: [
          {
            dataType: 'decimal',
            displayName: 'Min Shelf Life At Production, In Days',
            fieldFullPath: 'tdcProperties.unit_MinimumShelfLife',
          },
          {
            dataType: 'decimal',
            displayName: 'Max Shelf Life At Production, In Days',
            fieldFullPath: 'tdcProperties.unit_MaximumShelfLife',
          },
          {
            dataType: 'string',
            displayName: 'Shelf Life After Opening, In Days',
            fieldFullPath: 'tdcProperties.shelfLifeAfterOpening',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Dietary Certifications',
        fields: [
          {
            dataType: 'boolean',
            displayName: 'Kosher',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.kosherYN',
          },
          {
            dataType: 'string',
            displayName: 'Kosher Certifier',
            fieldFullPath: 'certification.kosherCertification',
          },
          {
            dataType: 'boolean',
            displayName: 'Organic',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.organicYN',
          },
          {
            dataType: 'string',
            displayName: 'Organic Certifier',
            fieldFullPath: 'certification.organicCertifier',
          },
          {
            dataType: 'boolean',
            displayName: 'Halal',
            fieldFullPath: 'qaSpecification.qaSpecProductSpecification.halalYN',
          },
          {
            dataType: 'string',
            displayName: 'Halal Certifier',
            fieldFullPath: 'certification.halalCertifier',
          },
          {
            dataType: 'boolean',
            displayName: 'Non-GMO',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.nonGMOYN',
          },
          {
            dataType: 'string',
            displayName: 'Non-GMO Certifier',
            fieldFullPath: 'certification.nonGMOCertifier',
          },
          {
            dataType: 'boolean',
            displayName: 'ISO',
            fieldFullPath: 'qaSpecification.qaSpecProductSpecification.iSOYN',
          },
          {
            dataType: 'string',
            displayName: 'ISO Certifier',
            fieldFullPath: 'certification.iSOCertifier',
          },
          {
            dataType: 'boolean',
            displayName: 'BRC',
            fieldFullPath: 'qaSpecification.qaSpecProductSpecification.bRCYN',
          },
          {
            dataType: 'string',
            displayName: 'BRC Certifier',
            fieldFullPath: 'certification.bRCCertifier',
          },
          {
            dataType: 'boolean',
            displayName: 'IFS',
            fieldFullPath: 'qaSpecification.qaSpecProductSpecification.iFSYN',
          },
          {
            dataType: 'string',
            displayName: 'IFS Certifier',
            fieldFullPath: 'certification.iFSCertifier',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Case Temperatures',
        fields: [
          {
            dataType: 'decimal',
            displayName: 'Case Temperature Range High',
            fieldFullPath: 'tdcProperties.case_TemperatureRangeHigh',
          },
          {
            dataType: 'decimal',
            displayName: 'Case Temperature Range Low',
            fieldFullPath: 'tdcProperties.case_TemperatureRangeLow',
          },
          {
            dataType: 'decimal',
            displayName: 'Case Shipping Temperature High',
            fieldFullPath: 'tdcProperties.case_ShippingTemperatureRangeHigh',
          },
          {
            dataType: 'decimal',
            displayName: 'Case Shipping Temperature Low',
            fieldFullPath: 'tdcProperties.case_ShippingTemperatureRangeLow',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Polyfluoroalkyl Substances (Pfas)',
        fields: [
          {
            dataType: 'string',
            displayName: 'Does this Product Intentionally Contain PFAS?',
            fieldFullPath: 'tdcProperties.productContainPfas',
          },
          {
            dataType: 'string',
            displayName:
              "Does this Product's Packaging Intentionally Contain PFAS?",
            fieldFullPath: 'tdcProperties.productPackagingContainPfas',
          },
          {
            dataType: 'string',
            displayName: 'PFAS Tested?',
            fieldFullPath: 'tdcProperties.pfasTested',
          },
          {
            dataType: 'string',
            displayName: 'PFAS Statement if Appropriate',
            fieldFullPath: 'tdcProperties.pfasStatement',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Organoleptic Characteristics',
        fields: null,
        childGroups: [
          {
            groupName: 'Appearance',
            fields: [
              {
                dataType: 'string',
                displayName: 'Preparation Method',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.preparationMethod.Appearance',
              },
              {
                dataType: 'string',
                displayName: 'Specification/Description/Target',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.specification.Appearance',
              },
              {
                dataType: 'string',
                displayName: 'Tolerance',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.tolerance.Appearance',
              },
              {
                dataType: 'string',
                displayName: 'Reject/Fail Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.rejectOrFailCriteria.Appearance',
              },
              {
                dataType: 'string',
                displayName: 'Frequency',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.frequency.Appearance',
              },
              {
                dataType: 'string',
                displayName: 'Release Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.releaseCriteria.Appearance',
              },
            ],
            childGroups: null,
          },
          {
            groupName: 'Color',
            fields: [
              {
                dataType: 'string',
                displayName: 'Preparation Method',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.preparationMethod.Color',
              },
              {
                dataType: 'string',
                displayName: 'Specification/Description/Target',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.specification.Color',
              },
              {
                dataType: 'string',
                displayName: 'Tolerance',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.tolerance.Color',
              },
              {
                dataType: 'string',
                displayName: 'Reject/Fail Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.rejectOrFailCriteria.Color',
              },
              {
                dataType: 'string',
                displayName: 'Frequency',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.frequency.Color',
              },
              {
                dataType: 'string',
                displayName: 'Release Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.releaseCriteria.Color',
              },
            ],
            childGroups: null,
          },
          {
            groupName: 'Aroma/Odor',
            fields: [
              {
                dataType: 'string',
                displayName: 'Preparation Method',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.preparationMethod.Odor',
              },
              {
                dataType: 'string',
                displayName: 'Specification/Description/Target',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.specification.Odor',
              },
              {
                dataType: 'string',
                displayName: 'Tolerance',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.tolerance.Odor',
              },
              {
                dataType: 'string',
                displayName: 'Reject/Fail Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.rejectOrFailCriteria.Odor',
              },
              {
                dataType: 'string',
                displayName: 'Frequency',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.frequency.Odor',
              },
              {
                dataType: 'string',
                displayName: 'Release Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.releaseCriteria.Odor',
              },
            ],
            childGroups: null,
          },
          {
            groupName: 'Taste',
            fields: [
              {
                dataType: 'string',
                displayName: 'Preparation Method',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.preparationMethod.Taste',
              },
              {
                dataType: 'string',
                displayName: 'Specification/Description/Target',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.specification.Taste',
              },
              {
                dataType: 'string',
                displayName: 'Tolerance',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.tolerance.Taste',
              },
              {
                dataType: 'string',
                displayName: 'Reject/Fail Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.rejectOrFailCriteria.Taste',
              },
              {
                dataType: 'string',
                displayName: 'Frequency',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.frequency.Taste',
              },
              {
                dataType: 'string',
                displayName: 'Release Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.releaseCriteria.Taste',
              },
            ],
            childGroups: null,
          },
          {
            groupName: 'Texture',
            fields: [
              {
                dataType: 'string',
                displayName: 'Preparation Method',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.preparationMethod.Texture',
              },
              {
                dataType: 'string',
                displayName: 'Specification/Description/Target',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.specification.Texture',
              },
              {
                dataType: 'string',
                displayName: 'Tolerance',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.tolerance.Texture',
              },
              {
                dataType: 'string',
                displayName: 'Reject/Fail Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.rejectOrFailCriteria.Texture',
              },
              {
                dataType: 'string',
                displayName: 'Frequency',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.frequency.Texture',
              },
              {
                dataType: 'string',
                displayName: 'Release Criteria',
                fieldFullPath:
                  'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsOrganolepticCharacteristics.releaseCriteria.Texture',
              },
            ],
            childGroups: null,
          },
        ],
      },
      {
        groupName: 'Physical & Chemical Characteristics',
        fields: [
          {
            dataType: 'string',
            displayName: 'Parameter',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.parameter',
          },
          {
            dataType: 'string',
            displayName: 'Method',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.method',
          },
          {
            dataType: 'string',
            displayName: 'Value (Food and Non-food Products)',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.value',
          },
          {
            dataType: 'string',
            displayName: 'Specification/Description/Target',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.specification',
          },
          {
            dataType: 'string',
            displayName: 'Tolerance',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.tolerance',
          },
          {
            dataType: 'string',
            displayName: 'Reject/Fail Criteria',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.rejectOrFailCriteria',
          },
          {
            dataType: 'string',
            displayName: 'Ref. Standard',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.referenceStandard',
          },
          {
            dataType: 'string',
            displayName: 'Ref. Method',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.referenceMethod',
          },
          {
            dataType: 'string',
            displayName: 'Test Source',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.test',
          },
          {
            dataType: 'string',
            displayName: 'Frequency',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.frequency',
          },
          {
            dataType: 'string',
            displayName: 'Release Criteria',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsPhysicalAndChemicalCharacteristics.releaseCriteria',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Contaminant Characteristics',
        fields: [
          {
            dataType: 'string',
            displayName: 'Parameter',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.parameter',
          },
          {
            dataType: 'string',
            displayName: 'Method',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.method',
          },
          {
            dataType: 'string',
            displayName: 'Value (Food and Non-food Products)',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.value',
          },
          {
            dataType: 'string',
            displayName: 'Specification/Description/Target',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.specification',
          },
          {
            dataType: 'string',
            displayName: 'Tolerance',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.tolerance',
          },
          {
            dataType: 'string',
            displayName: 'Reject/Fail Criteria',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.rejectOrFailCriteria',
          },
          {
            dataType: 'string',
            displayName: 'Ref. Standard',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.referenceStandard',
          },
          {
            dataType: 'string',
            displayName: 'Ref. Method',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.referenceMethod',
          },
          {
            dataType: 'string',
            displayName: 'Test Source',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.test',
          },
          {
            dataType: 'string',
            displayName: 'Frequency',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.frequency',
          },
          {
            dataType: 'string',
            displayName: 'Release Criteria',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsContaminantCharacteristics.releaseCriteria',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Microbiological Characteristics',
        fields: [
          {
            dataType: 'string',
            displayName: 'Parameter',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.parameter',
          },
          {
            dataType: 'string',
            displayName: 'Method',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.method',
          },
          {
            dataType: 'string',
            displayName: 'Value (Food and Non-food Products)',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.value',
          },
          {
            dataType: 'string',
            displayName: 'Specification/Description/Target',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.specification',
          },
          {
            dataType: 'string',
            displayName: 'Tolerance',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.tolerance',
          },
          {
            dataType: 'string',
            displayName: 'Reject/Fail Criteria',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.rejectOrFailCriteria',
          },
          {
            dataType: 'string',
            displayName: 'Ref. Standard',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.referenceStandard',
          },
          {
            dataType: 'string',
            displayName: 'Ref. Method',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.referenceMethod',
          },
          {
            dataType: 'string',
            displayName: 'Test Source',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.test',
          },
          {
            dataType: 'string',
            displayName: 'Frequency',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.frequency',
          },
          {
            dataType: 'string',
            displayName: 'Release Criteria',
            fieldFullPath:
              'qaSpecification.qaSpecProductSpecification.qaSpecProductSpecsMicrobiologicalCharacteristics.releaseCriteria',
          },
        ],
        childGroups: null,
      },
    ],
  },
  // {
  //   groupName: 'Fresh - Deli',
  //   fields: null,
  //   childGroups: [
  //     {
  //       groupName: 'Meat',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Protein Type',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliMeat.proteinType',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Protein %',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliMeat.protein',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Smoked',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliMeat.smoked',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Smoke Type',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliMeat.smokeType',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName:
  //             'Composition (Ex. Chopped and Formed, Whole Muscle, etc)',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliMeat.composition',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //     {
  //       groupName: 'Cheese',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Cheese Type',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.cheeseType',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Milk Type',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.milkType',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Process Flows',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.processFlows',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Aging Details',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.agingDetails',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Rind',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.rind',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'CCP (Critical Control Point)',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.cCP',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Rennet',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.rennet',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Pasteurizing Method',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.pasteurizingMethod',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Rind Edible',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.rindEdible',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Pasteurized',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.pasteurized',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Production Controls',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.productionControls',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Quality Controls',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshDeli.qaSpecFreshDeliCheese.qualityControls',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //   ],
  // },
  // {
  //   groupName: 'Fresh - Meat',
  //   fields: [
  //     {
  //       dataType: 'string',
  //       displayName: 'Breed',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.breed',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Feed',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.feed',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Type of Cut or Trim Spec',
  //       fieldFullPath: 'qaSpecification.typeOfCutOrTrimSpec',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Product Range Classification',
  //       fieldFullPath:
  //         'qaSpecification.qaSpecFreshMeat.productRangeClassification',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Irradiated',
  //       fieldFullPath:
  //         'foodAndBeverageIngredient.foodAndBeverageIngredient.ingredientFarmingProcessing.irradiatedCode',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Fortification',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.fortification',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Free Range',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.freeRange',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'USDA / AAFC Grading',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.usdaGrading',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Dry Aged',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.dryAged',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Pieces per Pound',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.piecesPerPound',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Cold Smoked',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshMeat.coldSmoked',
  //     },
  //   ],
  //   childGroups: [
  //     {
  //       groupName: 'Percentage',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Total Meat Protein Equivalent Min Percentage',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshMeat.totalMeatProteinMinPercentage',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Actual Total Meat Content Min Percentage',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshMeat.actualTotalMeatContentMinPercentage',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Actual Lean Mean Min Percentage',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshMeat.actualLeanMeatMinPercentage',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName:
  //             'Fat maximum percentage: total fat percentage on nutritional analyses',
  //           fieldFullPath: 'qaSpecification.qaSpecFreshMeat.fatMaxPercentage',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName:
  //             'Added rinds maximum percentage: added rind shall not exceed value',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshMeat.addedRindsMaxPercentage',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Added gelatin maximum percentage',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFreshMeat.addedGelatineMaxPercentage',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //   ],
  // },
  // {
  //   groupName: 'Fresh - Produce',
  //   fields: [
  //     {
  //       dataType: 'string',
  //       displayName: 'End Use',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshProduce.endUse',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Cooking Instructions/ Directions',
  //       fieldFullPath:
  //         'foodAndBeveragePreparationServing.preparationServing.preparationInstructions.value',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Produce Grading',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshProduce.produceGrading',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Fancy',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshProduce.fancy',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Ready to Eat',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshProduce.readytoEat',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Cleaning Method',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshProduce.cleaningMethod',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Risk Classification',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshProduce.riskClassification',
  //     },
  //   ],
  //   childGroups: null,
  // },
  // {
  //   groupName: 'Fresh - Seafood',
  //   fields: [
  //     {
  //       dataType: 'string',
  //       displayName: 'Genus',
  //       fieldFullPath: 'organismClassification.organismClassification.genus',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Species',
  //       fieldFullPath: 'organismClassification.organismClassification.species',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Type of Cut or Trim Spec',
  //       fieldFullPath: 'qaSpecification.typeOfCutOrTrimSpec',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Method of Production',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.methodOfProduction',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Method of Capture',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.methodOfCapture',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Source',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.source',
  //     },
  //     {
  //       dataType: 'decimal',
  //       displayName: 'Fish Est #',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.fishEstNo',
  //     },
  //     {
  //       dataType: 'decimal',
  //       displayName: 'FBC Logo #',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.fbcLogoNo',
  //     },
  //     {
  //       dataType: 'int',
  //       displayName: 'Identification Code(1-7)',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.identificationCode',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Production System - Applicable to Aquaculture',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.productionSystem',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Seafood Risk Category',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.seafoodRiskCategory',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Safe Handling Instructions',
  //       fieldFullPath: 'qaSpecification.safeHandlingInstructions',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Peeled, Deveined (Shrimp)',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.peeledDeveined',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Tail off or On (Shrimp)',
  //       fieldFullPath: 'qaSpecification.qaSpecFreshSeaFood.tailOffOrOn',
  //     },
  //   ],
  //   childGroups: null,
  // },
  {
    groupName: 'Ingredients',
    fields: [
      {
        dataType: 'string',
        displayName: 'Ingredient Statement',
        fieldFullPath: 'foodAndBeverageIngredient.ingredientStatement.value',
      },
      {
        dataType: 'string',
        displayName: 'Ingredient Claims',
        fieldFullPath: 'dProperties.ingredientsProductClaims',
      },
    ],
    childGroups: [
      {
        groupName: 'Ingredient',
        fields: [
          {
            dataType: 'string',
            displayName: 'Name of Ingredients',
            fieldFullPath:
              'qaSpecification.qaSpecIngredients.nameOfIngredients',
          },
          {
            dataType: 'string',
            displayName: 'Function',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.function',
          },
          {
            dataType: 'string',
            displayName: 'Origin',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.origin',
          },
          {
            dataType: 'string',
            displayName: 'Ingredient Supplier',
            fieldFullPath:
              'qaSpecification.qaSpecIngredients.ingredientSupplier',
          },
          {
            dataType: 'string',
            displayName: 'Country of Origin',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.countryOfOrigin',
          },
          {
            dataType: 'string',
            displayName: 'Religious Claim',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.religiousClaim',
          },
          {
            dataType: 'string',
            displayName: 'GMO',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.gmo',
          },
          {
            dataType: 'string',
            displayName: 'Bioengineered',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.bioengineered',
          },
          {
            dataType: 'string',
            displayName: 'Ionized',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.ionized',
          },
          {
            dataType: 'string',
            displayName: 'Allergens',
            fieldFullPath: 'qaSpecification.qaSpecIngredients.allergens',
          },
          {
            dataType: 'string',
            displayName: '% Added on Production',
            fieldFullPath:
              'qaSpecification.qaSpecIngredients.percentAddedOnProduction',
          },
          {
            dataType: 'decimal',
            displayName: '% in Final Product',
            fieldFullPath:
              'qaSpecification.qaSpecIngredients.percentInFinalProduct',
          },
        ],
        childGroups: null,
      },
    ],
  },
  {
    groupName: 'Allergens',
    fields: [
      {
        dataType: 'string',
        displayName: 'Allergen Statement',
        fieldFullPath: 'dProperties.allergenStatement',
      },
      {
        dataType: 'string',
        displayName: 'Allergen Specification Agency',
        fieldFullPath:
          'allergenInformation.allergenRelatedInformation.allergenSpecificationAgency',
      },
      {
        dataType: 'string',
        displayName: 'Allergen Specification Name',
        fieldFullPath:
          'allergenInformation.allergenRelatedInformation.allergenSpecificationName',
      },
    ],
    childGroups: null,
  },
  // {
  //   groupName: 'Components',
  //   fields: [
  //     {
  //       dataType: 'string',
  //       displayName: 'Product Claims',
  //       fieldFullPath: 'dProperties.componentsProductClaims',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'CAS / INCI / HS Code',
  //       fieldFullPath: 'dProperties.bpComponents.cAS_INCI_HSCode',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Function',
  //       fieldFullPath: 'dProperties.bpComponents.componentsFunction',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Manufacturer',
  //       fieldFullPath: 'dProperties.bpComponents.manufacturer',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Country of Origin',
  //       fieldFullPath: 'dProperties.bpComponents.componentsCountryOfOrigin',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Quantity in %',
  //       fieldFullPath: 'dProperties.bpComponents.quantityInPercent',
  //     },
  //     {
  //       dataType: 'decimal',
  //       displayName: 'Total Weight',
  //       fieldFullPath: 'dProperties.bpComponents.totalWeight',
  //     },
  //   ],
  //   childGroups: null,
  // },
  // {
  //   groupName: 'Facts Panel',
  //   fields: null,
  //   childGroups: [
  //     {
  //       groupName: 'Nutrition Label',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Label Type',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.nutrientFormatType',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Nutrient Basis Quantity Type Code',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.nutrientBasisQuantityTypeCode',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Nutrient Basis',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.nutrientBasisValue',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Unit of Measure',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.unitOfMeasure',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Servings Per Container Descriptor',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.servingPerContainerDescriptor',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Servings Per Container',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.numberOfServingsPerPackage',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Description',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.servingSizeDescription',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Size',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.servingSize',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Size Unit',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.servingSizeMeasurement',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Calories',
  //           fieldFullPath: 'qaSpecification.factsPanel.nutritionLabel.calories',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Ingredient Notice',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.ingredientNotice',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Footer Note',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.fdaLabelFootNote',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Language Code',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.nutritionLabel.languageCode',
  //         },
  //       ],
  //       childGroups: [
  //         {
  //           groupName: 'Nutrients',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Select Measurement Precision',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.nutritionLabel.nutrients.measurementPrecisionCode',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Daily Value',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.nutritionLabel.nutrients.dailyValueIntakePercent',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Quantity',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.nutritionLabel.nutrients.quantity',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Unit',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.nutritionLabel.nutrients.quantityUom',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //       ],
  //     },
  //     {
  //       groupName: 'Supplement Label',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Label Type',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.nutrientFormatType',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Servings Per Container Descriptor',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.servingPerContainerDescriptor',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Calories',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.calories',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: 'Calories from Fat',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.caloriesFromFat',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Footer Note',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.fdaLabelFootNote',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Other Ingredients',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.otherIngredients',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Language Code',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.supplementLabel.languageCode',
  //         },
  //       ],
  //       childGroups: [
  //         {
  //           groupName: 'Serving Size',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Description',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.servingSize.servingSizeDescription',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //         {
  //           groupName: 'Nutrients',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Part Of',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.nutrients.ingredientsPartOf',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Descriptor',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.nutrients.descriptor',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Quantity Description',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.nutrients.quantityDescription',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Daily Symbol',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.nutrients.dailySymbol',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //         {
  //           groupName: 'Dietary Ingredients',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Dietary Ingredient Name',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.ingredientName',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Part Of',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.ingredientsPartOf',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Descriptor',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.descriptor',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Quantity',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.quantity',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Unit',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.quantityUom',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Quantity Description',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.quantityDescription',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Daily Symbol',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.supplementLabel.dietaryIngredients.dailySymbol',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //       ],
  //     },
  //     {
  //       groupName: 'Drug Facts Label',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Label Type',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.drugFactsLabel.nutrientFormatType',
  //         },
  //       ],
  //       childGroups: [
  //         {
  //           groupName: 'Directions',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Age Group',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.drugFactsLabel.directions.ageGroup',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //         {
  //           groupName: 'Active Ingredients',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Dosage Unit',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.drugFactsLabel.activeIngredients.dosageUnit',
  //             },
  //           ],
  //           childGroups: [
  //             {
  //               groupName: 'Active Ingredients Detail',
  //               fields: [
  //                 {
  //                   dataType: 'string',
  //                   displayName: 'Purpose',
  //                   fieldFullPath:
  //                     'qaSpecification.factsPanel.drugFactsLabel.activeIngredients.activeIngredientsDetail.purposeDescriptor',
  //                 },
  //                 {
  //                   dataType: 'decimal',
  //                   displayName: 'Quantity',
  //                   fieldFullPath:
  //                     'qaSpecification.factsPanel.drugFactsLabel.activeIngredients.activeIngredientsDetail.quantity',
  //                 },
  //                 {
  //                   dataType: 'string',
  //                   displayName: 'Unit',
  //                   fieldFullPath:
  //                     'qaSpecification.factsPanel.drugFactsLabel.activeIngredients.activeIngredientsDetail.quantityUom',
  //                 },
  //               ],
  //               childGroups: null,
  //             },
  //           ],
  //         },
  //         {
  //           groupName: 'Uses',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Uses Text',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.drugFactsLabel.uses.useText',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //         {
  //           groupName: 'Inactive Ingredients',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Inactive Ingredients',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.drugFactsLabel.inactiveIngredients.inactiveIngredients',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //       ],
  //     },
  //     {
  //       groupName: 'Pet Nutrition Label',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Label Type',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.petNutritionLabel.nutrientFormatType',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Footer Note',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.petNutritionLabel.fdaLabelFootNote',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Enzymes And Microorganisms',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.petNutritionLabel.enzymesAndMicroorganisms',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Nutritional Adequacy Statement',
  //           fieldFullPath:
  //             'qaSpecification.factsPanel.petNutritionLabel.nutritionalAdequacyStatement',
  //         },
  //       ],
  //       childGroups: [
  //         {
  //           groupName: 'Calories Content',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Calories Content',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.caloriesContent.calorieContent',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Calories Per Cup',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.caloriesContent.caloriesPerCup',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Protein',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.caloriesContent.protein',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Fat',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.caloriesContent.fat',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Carbohydrate',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.caloriesContent.carbohydrate',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //         {
  //           groupName: 'Nutrients',
  //           fields: [
  //             {
  //               dataType: 'string',
  //               displayName: 'Measurement Limit',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.nutrients.limit',
  //             },
  //             {
  //               dataType: 'decimal',
  //               displayName: 'Quantity',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.nutrients.quantity',
  //             },
  //             {
  //               dataType: 'string',
  //               displayName: 'Quantity Unit',
  //               fieldFullPath:
  //                 'qaSpecification.factsPanel.petNutritionLabel.nutrients.quantityUom',
  //             },
  //           ],
  //           childGroups: null,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   groupName: 'Pet Food',
  //   fields: null,
  //   childGroups: [
  //     {
  //       groupName: 'Feeding',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Daily Feeding Recommendations',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecPetFood.dailyFeedingRecommendations',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Feeding Instructions',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.feedingInstructions',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Feeding Guidelines',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.feedingGuidelines',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Appetite Control Care Program',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecPetFood.appetiteControlCareProgram',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Use Only As Directed by your Veterinarian Statement',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecPetFood.veterinarianStatement',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //     {
  //       groupName: 'Details',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Benefits',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.benefits',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Warnings',
  //           fieldFullPath: 'tdcProperties.productWarningStatement',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Nutritional Adequacy Statement',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecPetFood.nutritionalAdequacyStatement',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Product Claims',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.productClaims',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Usage Instructions',
  //           fieldFullPath:
  //             'consumerInstructions.consumerInstructions.consumerUsageInstructions.value',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Protein Content Claim',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.proteinContentClaim',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //     {
  //       groupName: 'Additional Information',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Human Grade',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.humanGrade',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Contains Palm Oil',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.containsPalmOil',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName:
  //             'Ingredients in product from outside the United States',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.ingredientsOutsideUs',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //     {
  //       groupName: 'Geometries',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Shape 1',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.geometries.shape',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'H x W x D',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.geometries.dimension',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Weight',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.geometries.weight',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Variance',
  //           fieldFullPath: 'qaSpecification.qaSpecPetFood.geometries.variance',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //   ],
  // },
  // {
  //   groupName: 'Claims',
  //   fields: [
  //     {
  //       dataType: 'boolean',
  //       displayName: '1% For the Planet',
  //       fieldFullPath: 'tdcProperties.onePercentForThePlanetClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'ADA Seal of Acceptence',
  //       fieldFullPath: 'tdcProperties.aDASealofAcceptanceClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Bee Friendly',
  //       fieldFullPath: 'tdcProperties.beeBetterClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Bio-Based',
  //       fieldFullPath: 'tdcProperties.bioBasedYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Biodegradable - Packaging',
  //       fieldFullPath: 'tdcProperties.biodegradable',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Biodegradable - Product',
  //       fieldFullPath: 'tdcProperties.productIsBiodegradable',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Bio - Dynamic',
  //       fieldFullPath: 'tdcProperties.bioDynamicYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Bioengineered',
  //       fieldFullPath: 'tdcProperties.bioengineeredYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'BPA - Contains',
  //       fieldFullPath: 'tdcProperties.containsBPA',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'BPA Free Liner',
  //       fieldFullPath: 'tdcProperties.bPAFreeLiner',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'BPA Free Packaging',
  //       fieldFullPath: 'tdcProperties.bPAFreePackaging',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Carbon Footprint',
  //       fieldFullPath: 'tdcProperties.carbonFootprintYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Cradle To Cradle',
  //       fieldFullPath: 'tdcProperties.cradleToCradleYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Cruelty Free',
  //       fieldFullPath: 'tdcProperties.crueltyFreeYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Diabetic Friendly',
  //       fieldFullPath: 'tdcProperties.diabeticFriendlyYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Dolphin Friendly',
  //       fieldFullPath: 'qaSpecification.qaSpecClaims.dolphinFriendly',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Eco Fishery Claim',
  //       fieldFullPath: 'tdcProperties.ecoFisheryYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Fair Trade',
  //       fieldFullPath: 'tdcProperties.fairTradeYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'For Life',
  //       fieldFullPath: 'tdcProperties.forLifeYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Glyphosate Residue Free',
  //       fieldFullPath: 'tdcProperties.glyphosateResidueFreeClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'GMP Claim',
  //       fieldFullPath: 'tdcProperties.gMPYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Grass Fed',
  //       fieldFullPath: 'tdcProperties.grassFedYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Heart Healthy',
  //       fieldFullPath: 'tdcProperties.heartHealthyYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'High Potency',
  //       fieldFullPath: 'tdcProperties.highPotency',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'High Pressure Certified',
  //       fieldFullPath: 'tdcProperties.highPressureCertifiedClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Ingredients Sourced from China',
  //       fieldFullPath: 'tdcProperties.ingredientsChina',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'ITAL Certified Seal',
  //       fieldFullPath: 'tdcProperties.italCertifiedSealClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'ITAL Conscious Seal',
  //       fieldFullPath: 'tdcProperties.italConsciousSealClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'ITAL Sacrament Seal',
  //       fieldFullPath: 'tdcProperties.italSacramentSealClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Keto / Ketogenic',
  //       fieldFullPath: 'tdcProperties.ketoYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Live & Active Cultures',
  //       fieldFullPath: 'tdcProperties.liveAndActiveCulture',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Low Glycemic',
  //       fieldFullPath: 'tdcProperties.lowGlycemicYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Made with Organic Ingredients',
  //       fieldFullPath: 'tdcProperties.organicIngredientsMadeWith',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Non-irradiated Ingredients',
  //       fieldFullPath: 'qaSpecification.qaSpecClaims.nonIrradiatedIngredients',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'NPA',
  //       fieldFullPath: 'tdcProperties.nPAYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'PACA Compliant',
  //       fieldFullPath: 'tdcProperties.pACAYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Paleo',
  //       fieldFullPath: 'tdcProperties.paleoYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'PASA Compliant',
  //       fieldFullPath: 'tdcProperties.pASAYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Plant Based / Derived',
  //       fieldFullPath: 'tdcProperties.plantBasedDerivedClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Rain Forest Alliance',
  //       fieldFullPath: 'tdcProperties.rainForestAllianceYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'REAL Certified',
  //       fieldFullPath: 'tdcProperties.rEALCertifiedClaim',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Real Dairy Seal',
  //       fieldFullPath: 'tdcProperties.realSealYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Vegan',
  //       fieldFullPath: 'tdcProperties.veganYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Vegetarian',
  //       fieldFullPath: 'tdcProperties.vegetarianYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Vitaculture',
  //       fieldFullPath: 'tdcProperties.viticultureYN',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Water Quality Association',
  //       fieldFullPath: 'tdcProperties.waterQualityAssociationCertified',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'WERCS Registered',
  //       fieldFullPath: 'tdcProperties.wERCSRegistered',
  //     },
  //     {
  //       dataType: 'boolean',
  //       displayName: 'Whole Grain',
  //       fieldFullPath: 'tdcProperties.wholeGrainYN',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Contains',
  //       fieldFullPath: 'tdcProperties.contains',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Does Not Contain',
  //       fieldFullPath: 'tdcProperties.doesNotContain',
  //     },
  //   ],
  //   childGroups: null,
  // },
  // {
  //   groupName: 'Formula',
  //   fields: [
  //     {
  //       dataType: 'string',
  //       displayName: 'Active Ingredients',
  //       fieldFullPath: 'qaSpecification.formulaActiveIngredients',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Inactive Ingredients',
  //       fieldFullPath: 'qaSpecification.formulaInactiveIngredients',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Ingredients Purpose / Strength',
  //       fieldFullPath: 'qaSpecification.formulaIngredientsPurposeStrength',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Other Ingredients',
  //       fieldFullPath: 'qaSpecification.formulaOtherIngredients',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Formula/Ingredient Claims',
  //       fieldFullPath: 'qaSpecification.formulaProductClaims',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Free From',
  //       fieldFullPath: 'qaSpecification.formulaFreeFrom',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'Ingredient Definitions',
  //       fieldFullPath: 'qaSpecification.formulaIngredientDefinitions',
  //     },
  //     {
  //       dataType: 'string',
  //       displayName: 'EPA Registration Number',
  //       fieldFullPath: 'qaSpecification.epaRegistrationNumber',
  //     },
  //   ],
  //   childGroups: [
  //     {
  //       groupName: 'Formula Grid',
  //       fields: [
  //         {
  //           dataType: 'string',
  //           displayName: 'Common/Label Name',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.salesDesignation',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Technical Designation (IUPAC/INCI)',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.technicalDesignation',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'CAS Number',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.cASNumber',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Country',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.country',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Function',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.function',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Classification Risk Phrases',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFormula.classificationAndRiskPhrases',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Origin',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.origin',
  //         },
  //         {
  //           dataType: 'string',
  //           displayName: 'Origin Specification',
  //           fieldFullPath: 'qaSpecification.qaSpecFormula.originSpecification',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: '% (m/m) subtance in the raw material',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFormula.percentOfRawMaterialSubstance',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName:
  //             '% (m/m) raw material incorporated in the finished product',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFormula.percentOfIncorporatedRawMaterial',
  //         },
  //         {
  //           dataType: 'decimal',
  //           displayName: '% (m/m) subtance in the finished product',
  //           fieldFullPath:
  //             'qaSpecification.qaSpecFormula.percentOfFinishedProductSubstance',
  //         },
  //       ],
  //       childGroups: null,
  //     },
  //   ],
  // },
  {
    groupName: 'Manufacturing Process',
    fields: null,
    childGroups: [
      {
        groupName: 'Process Stage',
        fields: [
          {
            dataType: 'string',
            displayName: 'Process / Stage',
            fieldFullPath:
              'qaSpecification.qaSpecManufacturingProcesses.processStage',
          },
          {
            dataType: 'string',
            displayName: 'Nature of the tests',
            fieldFullPath:
              'qaSpecification.qaSpecManufacturingProcesses.natureOfTheTests',
          },
          {
            dataType: 'string',
            displayName: 'Target value and Tolerances',
            fieldFullPath:
              'qaSpecification.qaSpecManufacturingProcesses.targetValueAndTolerances',
          },
          {
            dataType: 'string',
            displayName: 'Frequency',
            fieldFullPath:
              'qaSpecification.qaSpecManufacturingProcesses.frequency',
          },
          {
            dataType: 'string',
            displayName: 'Test',
            fieldFullPath: 'qaSpecification.qaSpecManufacturingProcesses.test',
          },
          {
            dataType: 'string',
            displayName: 'Recognized Methods',
            fieldFullPath:
              'qaSpecification.qaSpecManufacturingProcesses.recognizedMethods',
          },
          {
            dataType: 'string',
            displayName: 'Critical Point Established in HACCP',
            fieldFullPath:
              'qaSpecification.qaSpecManufacturingProcesses.criticalPointEstablishedInHACCP',
          },
        ],
        childGroups: null,
      },
    ],
  },
  {
    groupName: 'Labeling',
    fields: [
      {
        dataType: 'string',
        displayName: 'Storage Instructions',
        fieldFullPath:
          'consumerInstructions.consumerInstructions.consumerStorageInstructions.value',
      },
      {
        dataType: 'string',
        displayName: 'Handling Instructions',
        fieldFullPath:
          'tradeItemHandling.tradeItemHandlingInformation.handlingInstructionsDescription.value',
      },
      {
        dataType: 'string',
        displayName: 'Thawing Instructions',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.thawingInstructions',
      },
      {
        dataType: 'string',
        displayName: 'Warning / Caution Statement',
        fieldFullPath:
          'packagingMarking.packagingMarking.consumerWarningInformation.consumerWarningDescription.value',
      },
      {
        dataType: 'string',
        displayName: 'Front of Pack Icons',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.frontOfPackIcons',
      },
      {
        dataType: 'string',
        displayName: 'Recyclable',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.recyclable',
      },
      {
        dataType: 'string',
        displayName: 'Recyclable Types',
        fieldFullPath:
          'packagingInformation.packaging.packagingRecyclingSchemeCode',
      },
      {
        dataType: 'decimal',
        displayName: 'Total Recycled Content Percentage',
        fieldFullPath:
          'sustainability.sustainabilityInformation.totalRecyclableContentPercentage',
      },
      {
        dataType: 'decimal',
        displayName: 'Post Consumer Recycled Content Percentage',
        fieldFullPath:
          'sustainability.sustainabilityInformation.postConsumerRecycledContentPercentage',
      },
      {
        dataType: 'string',
        displayName: 'Packaging Type',
        fieldFullPath: 'packagingInformation.packaging.packagingTypeCode',
      },
      {
        dataType: 'string',
        displayName: 'Packaging Material',
        fieldFullPath:
          'packagingInformation.packaging.packagingMaterial.packagingMaterialTypeCode',
      },
      {
        dataType: 'boolean',
        displayName: 'QR Code',
        fieldFullPath: 'tdcProperties.qRCode',
      },
      {
        dataType: 'string',
        displayName: 'Additional Languages on Label',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.bilingual',
      },
      {
        dataType: 'string',
        displayName: 'Secondary Language',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.secondaryLanguage',
      },
      {
        dataType: 'string',
        displayName: 'Romance Copy',
        fieldFullPath: 'eCommerce.rivirMarketingDescription',
      },
      {
        dataType: 'string',
        displayName: 'Usage',
        fieldFullPath:
          'consumerInstructions.consumerInstructions.consumerUsageInstructions.value',
      },
      {
        dataType: 'string',
        displayName: 'Cooking Instructions/ Directions',
        fieldFullPath:
          'foodAndBeveragePreparationServing.preparationServing.preparationInstructions.value',
      },
      {
        dataType: 'string',
        displayName: 'Recipe',
        fieldFullPath:
          'foodAndBeveragePreparationServing.preparationServing.recipe.value',
      },
      {
        dataType: 'string',
        displayName: 'Other Certifications',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.otherCertifications',
      },
      {
        dataType: 'boolean',
        displayName: 'Contains Food Grade Plastics',
        fieldFullPath: 'tdcProperties.hasFoodGradePlasticsCertifier',
      },
      {
        dataType: 'boolean',
        displayName: 'Made With Recycled Material',
        fieldFullPath: 'tdcProperties.recycledMaterial',
      },
      {
        dataType: 'boolean',
        displayName: 'Soy Ink',
        fieldFullPath: 'tdcProperties.soyInk',
      },
      {
        dataType: 'boolean',
        displayName: 'Vegetable Based Ink',
        fieldFullPath: 'tdcProperties.vegetableBasedInk',
      },
      {
        dataType: 'string',
        displayName: 'Allergen Statement',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.allergenStatement',
      },
      {
        dataType: 'string',
        displayName: 'Ingredient Statement',
        fieldFullPath: 'qaSpecification.qaSpecPackaging.ingredientStatement',
      },

      {
        dataType: 'string',
        displayName: 'Product Contains Bioengineered Ingredients',
        fieldFullPath:
          'qaSpecification.qaSpecPackaging.productContainsBioengineeredIngredients',
      },
      {
        dataType: 'string',
        displayName: 'Bioengineered Ingredients Statement',
        fieldFullPath:
          'qaSpecification.qaSpecPackaging.bioengineeredIngredientsStatement',
      },
    ],
    childGroups: [
      {
        groupName: 'Product',
        fields: [
          {
            dataType: 'string',
            displayName: 'Product Name',
            fieldFullPath: 'productName',
          },
          { dataType: 'string', displayName: 'UPC12', fieldFullPath: 'upc12' },
          {
            dataType: 'int',
            displayName: 'Truncated UPC',
            fieldFullPath: 'qaSpecification.qaSpecPackaging.truncatedUpc',
          },
          {
            dataType: 'string',
            displayName: 'Secondary Descriptor',
            fieldFullPath:
              'dProperties.bpSKULabelling.leftLanguage.frontPanelSecondaryDescrip',
          },
          {
            dataType: 'string',
            displayName: 'Tertiary Descriptor',
            fieldFullPath:
              'dProperties.bpSKULabelling.leftLanguage.tertiaryDescriptor',
          },
          {
            dataType: 'decimal',
            displayName: 'Size',
            fieldFullPath: 'primarySize',
          },
          {
            dataType: 'string',
            displayName: 'UOM',
            fieldFullPath: 'primarySizeUOM',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Product Claims',
        fields: [
          {
            dataType: 'string',
            displayName: 'Claim 1',
            fieldFullPath: 'qaSpecification.qaSpecPackaging.claim1',
          },
          {
            dataType: 'string',
            displayName: 'Claim 2',
            fieldFullPath: 'qaSpecification.qaSpecPackaging.claim2',
          },
          {
            dataType: 'string',
            displayName: 'Claim 3',
            fieldFullPath: 'qaSpecification.qaSpecPackaging.claim3',
          },
          {
            dataType: 'string',
            displayName: 'Claim 4',
            fieldFullPath: 'qaSpecification.qaSpecPackaging.claim4',
          },
          {
            dataType: 'string',
            displayName: 'Claim 5',
            fieldFullPath: 'qaSpecification.qaSpecPackaging.claim5',
          },
        ],
        childGroups: null,
      },
    ],
  },
  {
    groupName: 'Contacts',
    fields: null,
    childGroups: [
      {
        groupName: 'Primary Business Contact',
        fields: [
          {
            dataType: 'string',
            displayName: 'Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryBusinessContact.name',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryBusinessContact.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryBusinessContact.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryBusinessContact.country',
          },
          {
            dataType: 'string',
            displayName: 'Phone Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryBusinessContact.phone',
          },
          {
            dataType: 'string',
            displayName: 'Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryBusinessContact.email',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Primary QC Contact',
        fields: [
          {
            dataType: 'string',
            displayName: 'Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryQcContact.name',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryQcContact.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryQcContact.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryQcContact.country',
          },
          {
            dataType: 'string',
            displayName: 'Phone Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryQcContact.phone',
          },
          {
            dataType: 'string',
            displayName: 'Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.primaryQcContact.email',
          },
        ],
        childGroups: null,
      },
      {
        groupName: '24 Hour Contact',
        fields: [
          {
            dataType: 'string',
            displayName: 'Name',
            fieldFullPath: 'qaSpecification.qaSpecContacts._24HourContact.name',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts._24HourContact.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts._24HourContact.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts._24HourContact.country',
          },
          {
            dataType: 'string',
            displayName: 'Phone Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts._24HourContact.phone',
          },
          {
            dataType: 'string',
            displayName: 'Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts._24HourContact.email',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Packaging Contact',
        fields: [
          {
            dataType: 'string',
            displayName: 'Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.packagingContact.name',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.packagingContact.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.packagingContact.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.packagingContact.country',
          },
          {
            dataType: 'string',
            displayName: 'Phone Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.packagingContact.phone',
          },
          {
            dataType: 'string',
            displayName: 'Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.packagingContact.email',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Production Facility #1',
        fields: [
          {
            dataType: 'string',
            displayName: 'Facility Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.name',
          },
          {
            dataType: 'string',
            displayName: 'Facility Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Facility Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.country',
          },
          {
            dataType: 'string',
            displayName: 'Fax Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.faxNumber',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.facilityPlantManagerContactEmail',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.facilityPlantManager',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Phone',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.facilityPlantManagerContactPhone',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.facilityQaContactEmail',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.facilityQaContact',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Phone',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo1.facilityQaContactPhone',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Production Facility #2',
        fields: [
          {
            dataType: 'string',
            displayName: 'Facility Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.name',
          },
          {
            dataType: 'string',
            displayName: 'Facility Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Facility Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.country',
          },
          {
            dataType: 'string',
            displayName: 'Fax Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.faxNumber',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.facilityPlantManagerContactEmail',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.facilityPlantManager',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Phone',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.facilityPlantManagerContactPhone',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.facilityQaContactEmail',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.facilityQaContact',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Phone',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo2.facilityQaContactPhone',
          },
        ],
        childGroups: null,
      },
      {
        groupName: 'Production Facility #3',
        fields: [
          {
            dataType: 'string',
            displayName: 'Facility Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.name',
          },
          {
            dataType: 'string',
            displayName: 'Facility Address Line 1',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.addressLine1',
          },
          {
            dataType: 'string',
            displayName: 'Facility Address Line 2',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.addressLine2',
          },
          {
            dataType: 'string',
            displayName: 'Country',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.country',
          },
          {
            dataType: 'string',
            displayName: 'Fax Number',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.faxNumber',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.facilityPlantManagerContactEmail',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.facilityPlantManager',
          },
          {
            dataType: 'string',
            displayName: 'Facility Plant Manager Phone',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.facilityPlantManagerContactPhone',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Email',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.facilityQaContactEmail',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Name',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.facilityQaContact',
          },
          {
            dataType: 'string',
            displayName: 'Facility QA Phone',
            fieldFullPath:
              'qaSpecification.qaSpecContacts.productionFacilityNo3.facilityQaContactPhone',
          },
        ],
        childGroups: null,
      },
    ],
  },
  {
    groupName: 'Product Contains',
    fields: [
      {
        dataType: 'string',
        displayName: '1-Bromopropane',
        fieldFullPath: 'qaSpecification.qaSpecProductContains._1_Bromopropane',
      },
      {
        dataType: 'string',
        displayName: 'Asbestos',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.asbestos',
      },
      {
        dataType: 'string',
        displayName: '1.4-dioxane',
        fieldFullPath: 'qaSpecification.qaSpecProductContains._1_4_Dioxane',
      },
      {
        dataType: 'string',
        displayName:
          'Cyclic Aliphatic Bromides Cluster of flame retardants (HBCD)',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.hbcd',
      },
      {
        dataType: 'string',
        displayName: 'Octamethylcyclotetrasiloxane (D4)',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.d4',
      },
      {
        dataType: 'string',
        displayName: 'Lead and Lead Compounds',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.leadCompounds',
      },
      {
        dataType: 'string',
        displayName: 'Cadmium and Cadmium Compounds',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.cadmiumCompounds',
      },
      {
        dataType: 'string',
        displayName: 'Bisphenol A (BPA)',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.bisphenolA',
      },
      {
        dataType: 'string',
        displayName: 'Diethyl phthalate',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.diethylPhthalate',
      },
      {
        dataType: 'string',
        displayName: 'Dibutyl phthalate',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.dibutylPhthalate',
      },
      {
        dataType: 'string',
        displayName: 'Tetrachloroethylene (PERC)',
        fieldFullPath:
          'qaSpecification.qaSpecProductContains.tetrachloroethylene',
      },
      {
        dataType: 'string',
        displayName: 'Formaldehyde',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.formaldehyde',
      },
      {
        dataType: 'string',
        displayName: 'Toluene',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.toluene',
      },
      {
        dataType: 'string',
        displayName: 'Nonylphenol Ethoxylates',
        fieldFullPath:
          'qaSpecification.qaSpecProductContains.nonylphenolEthoxylates',
      },
      {
        dataType: 'string',
        displayName: 'Butylparaben',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.butylparaben',
      },
      {
        dataType: 'string',
        displayName: 'Propylparaben',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.propylparaben',
      },
      {
        dataType: 'string',
        displayName: 'Trichloroethylene',
        fieldFullPath:
          'qaSpecification.qaSpecProductContains.trichloroethylene',
      },
      {
        dataType: 'string',
        displayName: 'Triclocarban',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.triclocarban',
      },
      {
        dataType: 'string',
        displayName: 'Triclosan',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.triclosan',
      },
      {
        dataType: 'string',
        displayName: 'Palm Oil',
        fieldFullPath: 'qaSpecification.qaSpecProductContains.palmOil',
      },
    ],
    childGroups: null,
  },
];
